export const EXTERNAL_FILE_LINK_SERVICE_TYPE = {
	box: "box",
	GoogleDrive: "google-drive",
	Dropbox: "dropbox",
	OneDrive: "onedrive",
	Others: "others",
	Undef: null,
} as const;

export type ExternalFileLinkServiceType =
	(typeof EXTERNAL_FILE_LINK_SERVICE_TYPE)[keyof typeof EXTERNAL_FILE_LINK_SERVICE_TYPE];
